import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "普通" },
  { value: 2, text: "当座" },
]);
